import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";

const { default: sheet } = CSS_MODULE_SCRIPTS
	? await import("./util.module.css", { with: { type: "css" } })
	: await importCss("./util.module.css", import.meta.url);
export default adopt(sheet);
